import React from "react";
import { 
  Box, 
  Container, 
  Typography, 
  Breadcrumbs, 
  Link, 
  Divider, 
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from "@mui/material";
import FooterSection from "../home/FooterSection";

// Custom bullet point component
const BulletPoint = () => (
  <Box 
    component="span" 
    sx={{ 
      display: "inline-block",
      width: 6,
      height: 6,
      borderRadius: "50%",
      backgroundColor: "#0f84fe",
      marginRight: 1.5,
      flexShrink: 0,
      mt: 0.8
    }} 
  />
);

const TermsAndConditions = () => {
  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
      {/* <NavigationSection /> */}
      
      {/* Header Banner */}
      <Box
        sx={{
          bgcolor: "#232323",
          color: "white",
          py: { xs: 6, md: 8 },
          mb: { xs: 4, md: 6 }
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: { xs: "2rem", md: "3rem" },
              fontWeight: 600,
              mb: 2
            }}
          >
            Terms and Conditions
          </Typography>
          
          <Breadcrumbs 
            aria-label="breadcrumb" 
            sx={{ 
              color: "#8d8d8b",
              "& .MuiBreadcrumbs-separator": {
                mx: 1
              }
            }}
          >
            <Link 
              underline="hover" 
              color="inherit" 
              href="/"
              sx={{ 
                "&:hover": { color: "#0f84fe" },
                transition: "color 0.2s"
              }}
            >
              Home
            </Link>
            <Typography color="#8d8d8b">Terms and Conditions</Typography>
          </Breadcrumbs>
        </Container>
      </Box>
      
      {/* Main Content */}
      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Paper 
          elevation={0}
          sx={{ 
            p: { xs: 3, md: 5 },
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            borderRadius: 2
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#0f84fe",
              fontWeight: 600,
              mb: 1,
              textTransform: "uppercase",
              letterSpacing: 1
            }}
          >
            Last Updated: May 19, 2025
          </Typography>
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Introduction
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 3, lineHeight: 1.7 }}>
            Welcome toAlfa 2020 s.r.o.. ("we", "our", or "us"). These Terms and Conditions govern your 
            use of our remote technical support, software installation, network setup and troubleshooting 
            services (collectively, the "Services"), including our website and interactions with our support 
            technicians.
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 4, lineHeight: 1.7 }}>
            By accessing or using our Services, you agree to be bound by these Terms and Conditions. If you 
            disagree with any part of these terms, you may not access or use our Services.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Service Description
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 3, lineHeight: 1.7 }}>
            TechSupport Pro provides remote technical support, software installation, network setup and 
            troubleshooting services to individuals and businesses. Our Services include but are not limited to:
          </Typography>
          
          <List sx={{ pl: 2, mb: 4 }}>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Remote computer diagnostics and troubleshooting" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Software installation, configuration, and updates" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Network setup, configuration, and security" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Virus and malware removal" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Data backup and recovery solutions" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Email setup and configuration" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Hardware consultation and recommendation" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
          </List>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            User Responsibilities
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 3, lineHeight: 1.7 }}>
            By using our Services, you agree to:
          </Typography>
          
          <Box sx={{ mb: 4 }}>
            <Typography variant="h3" component="h3" sx={{ fontSize: "1.3rem", fontWeight: 600, mb: 2 }}>
              Provide Accurate Information
            </Typography>
            
            <Typography paragraph sx={{ color: "#444", lineHeight: 1.7 }}>
              You will provide accurate, current, and complete information about yourself and your devices 
              when requested during service delivery. This includes but is not limited to system specifications, 
              software versions, and problem descriptions.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 4 }}>
            <Typography variant="h3" component="h3" sx={{ fontSize: "1.3rem", fontWeight: 600, mb: 2 }}>
              Backup Your Data
            </Typography>
            
            <Typography paragraph sx={{ color: "#444", lineHeight: 1.7 }}>
              You are responsible for backing up your data before we provide any Services. While we take 
              precautions to avoid data loss, we cannot guarantee that no data loss will occur during the 
              provision of our Services. We are not responsible for any lost data, regardless of the cause.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 4 }}>
            <Typography variant="h3" component="h3" sx={{ fontSize: "1.3rem", fontWeight: 600, mb: 2 }}>
              Maintain Legal Software Licenses
            </Typography>
            
            <Typography paragraph sx={{ color: "#444", lineHeight: 1.7 }}>
              You warrant that you have legally obtained all software licenses for any software you request us 
              to install, configure, or troubleshoot. We reserve the right to refuse service for any software 
              we reasonably believe to be illegally obtained.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 4 }}>
            <Typography variant="h3" component="h3" sx={{ fontSize: "1.3rem", fontWeight: 600, mb: 2 }}>
              Cooperate with Our Technicians
            </Typography>
            
            <Typography paragraph sx={{ color: "#444", lineHeight: 1.7 }}>
              You agree to cooperate with our technicians and follow their instructions during service delivery. 
              This may include providing necessary access to your systems, answering questions about your setup, 
              and performing tasks as directed by our technicians.
            </Typography>
          </Box>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Service Access and Remote Assistance
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 3, lineHeight: 1.7 }}>
            To provide our Services, our technicians may need to access your device remotely using secure remote 
            access software. By using our Services, you acknowledge and agree that:
          </Typography>
          
          <List sx={{ pl: 2, mb: 4 }}>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="You authorize our technicians to remotely access and control your device to provide the requested Services" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="You are responsible for maintaining a stable internet connection during remote service sessions" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="You may observe all actions performed by our technicians and can terminate the remote session at any time" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="We will maintain records of all remote sessions for quality and security purposes" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
          </List>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Payment and Billing
          </Typography>
          
          <Box sx={{ mb: 4 }}>
            <Typography variant="h3" component="h3" sx={{ fontSize: "1.3rem", fontWeight: 600, mb: 2 }}>
              Service Fees
            </Typography>
            
            <Typography paragraph sx={{ color: "#444", lineHeight: 1.7 }}>
              Our Service fees are published on our website and are subject to change without notice. By 
              purchasing our Services, you agree to pay all fees associated with the Services you select. 
              All fees are charged in advance of service delivery unless otherwise specified.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 4 }}>
            <Typography variant="h3" component="h3" sx={{ fontSize: "1.3rem", fontWeight: 600, mb: 2 }}>
              Subscription Services
            </Typography>
            
            <Typography paragraph sx={{ color: "#444", lineHeight: 1.7 }}>
              For subscription-based Services, you authorize us to charge your payment method on a recurring 
              basis. Subscriptions will automatically renew for successive periods unless canceled at least 
              14 days before the end of the current subscription period. You can cancel your subscription 
              by contacting our customer service.
            </Typography>
          </Box>
          
          <Box sx={{ mb: 4 }}>
            <Typography variant="h3" component="h3" sx={{ fontSize: "1.3rem", fontWeight: 600, mb: 2 }}>
              Refunds
            </Typography>
            
            <Typography paragraph sx={{ color: "#444", lineHeight: 1.7 }}>
              We offer a satisfaction guarantee for our Services. If you are not satisfied with the Services 
              provided, you may request a refund within 30 days of service delivery. Refund eligibility is 
              determined on a case-by-case basis and at our sole discretion.
            </Typography>
          </Box>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Intellectual Property
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 3, lineHeight: 1.7 }}>
            All content on our website, including but not limited to text, graphics, logos, icons, images, 
            audio clips, digital downloads, and software, is the property of TechSupport Pro or our content 
            suppliers and is protected by copyright, trademark, and other intellectual property laws.
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 4, lineHeight: 1.7 }}>
            You may not reproduce, distribute, modify, create derivative works from, publicly display, publicly 
            perform, republish, download, store, or transmit any of the material on our website without our prior 
            written consent, except as provided in these Terms and Conditions.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Limitation of Liability
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 3, lineHeight: 1.7 }}>
            To the maximum extent permitted by law, in no event shall TechSupport Pro, its directors, employees, 
            partners, agents, suppliers, or affiliates be liable for any indirect, incidental, special, consequential, 
            or punitive damages, including without limitation, loss of profits, data, use, goodwill, business 
            interruption, or other intangible losses, resulting from:
          </Typography>
          
          <List sx={{ pl: 2, mb: 4 }}>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Your access to or use of or inability to access or use our Services" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Any conduct or content of any third party on our Services" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Any content obtained from our Services" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: 0.8 }}>
                <BulletPoint />
              </ListItemIcon>
              <ListItemText 
                primary="Unauthorized access, use, or alteration of your transmissions or content" 
                sx={{ 
                  m: 0,
                  "& .MuiTypography-root": { 
                    color: "#444", 
                    lineHeight: 1.7 
                  } 
                }} 
              />
            </ListItem>
          </List>
          
          <Typography paragraph sx={{ color: "#444", mb: 4, lineHeight: 1.7 }}>
            Our liability is limited to the maximum extent permitted by law and shall not exceed the amount 
            paid by you for the specific service that gave rise to the claim.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Warranty Disclaimer
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 4, lineHeight: 1.7 }}>
            Our Services are provided "as is" and "as available" without any warranty of any kind, either 
            express or implied, including but not limited to the implied warranties of merchantability, 
            fitness for a particular purpose, or non-infringement. We do not guarantee that our Services 
            will meet your requirements, be uninterrupted, timely, secure, or error-free.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Indemnification
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 4, lineHeight: 1.7 }}>
            You agree to defend, indemnify, and hold harmless TechSupport Pro, its directors, employees, 
            partners, agents, suppliers, and affiliates from and against any claims, liabilities, damages, 
            judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) 
            arising out of or relating to your violation of these Terms and Conditions or your use of our 
            Services.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Termination
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 3, lineHeight: 1.7 }}>
            We may terminate or suspend your access to our Services immediately, without prior notice or 
            liability, for any reason whatsoever, including, without limitation, if you breach these Terms 
            and Conditions.
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 4, lineHeight: 1.7 }}>
            All provisions of these Terms and Conditions which by their nature should survive termination 
            shall survive termination, including, without limitation, ownership provisions, warranty 
            disclaimers, indemnity, and limitations of liability.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Governing Law
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 4, lineHeight: 1.7 }}>
            These Terms and Conditions shall be governed by and construed in accordance with the laws of 
            the State of California, without regard to its conflict of law provisions. Any dispute arising 
            from or relating to these Terms and Conditions shall be subject to the exclusive jurisdiction 
            of the state and federal courts located in San Francisco County, California.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Changes to These Terms and Conditions
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 4, lineHeight: 1.7 }}>
            We reserve the right to modify or replace these Terms and Conditions at any time at our sole 
            discretion. The most current version will be posted on our website with the "Last Updated" date. 
            Your continued use of our Services after any such changes constitutes your acceptance of the 
            new Terms and Conditions.
          </Typography>
          
          <Divider sx={{ my: 4 }} />
          
          <Typography variant="h2" component="h2" sx={{ fontSize: "1.75rem", fontWeight: 600, mb: 3 }}>
            Contact Us
          </Typography>
          
          <Typography paragraph sx={{ color: "#444", mb: 2, lineHeight: 1.7 }}>
            If you have any questions about these Terms and Conditions, please contact us:
          </Typography>
          
          <Box sx={{ ml: 2, mb: 4 }}>
            <Typography paragraph sx={{ color: "#444", mb: 1, lineHeight: 1.7 }}>
              <strong>By email:</strong> info@alfagroup-24.com
            </Typography>
            
            <Typography paragraph sx={{ color: "#444", lineHeight: 1.7 }}>
              <strong>By mail:</strong> Alfa 2020 s.r.o.<br />
              Veľká Okružná 17 
              Žilina 010 01 
            </Typography>
          </Box>
        </Paper>
      </Container>
      
      <FooterSection />
    </Box>
  );
};

export default TermsAndConditions;